import React, { Component, Fragment } from "react";
import { SystemServices, UtilityService } from "../../services";
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Button from "../../components/Buttons/Button";
import Field from "../../components/Common/Field/Field";

class SystemSupplier extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    systemSupplier: {
      supplierCode: "",
      supplierName: "",
      supplierPhone: "",
      supplierEmail: "",
      supplierFax: "",
      supplierAddress: ""
    }
  };

  componentWillMount() {
    const action = this.props.location.state.action;
    const _id = this.props.location.state._id;

    this.setState({ action, _id });

    if (_id !== "") {
      SystemServices.viewystemSupplier(_id)
        .then(response => {
          if (response.status === 200) {    
            let systemSupplier = {...this.state.systemSupplier}
            Object.keys(systemSupplier).forEach(key =>{
              systemSupplier[key] = response.text.data[key]
            })
            let _id = response.text.data._id
            this.setState({
                systemSupplier,
                _id
            })
          }
        })
        .catch(error => {
          this.props.getalertMessage('error',error.toString());
        });
    }
    if (action === "view") {
      this.setState({ disabled: true });
    }
  }

  createSupplier = () => {
    
    let systemSupplier = {...this.state.systemSupplier}
    
    if(this.state._id){
        systemSupplier._id = this.state._id
    }

    SystemServices.SystemSupplier(systemSupplier,this.state.action).then(response => {
        if(response.status === 200){
            if (response.text.message === "Successfully Added") {
                    this.props.getalertMessage('success',response.text.message)
                    let systemSupplier = {...this.state.systemSupplier}
                    Object.keys(systemSupplier).forEach(element => {
                        systemSupplier[element] =''
                    });
                    
                    this.setState({
                        systemSupplier
                    })
            } else if (response.text.message === "Supplier Code exists") {
                this.props.getalertMessage('warning',response.text.message)
            } else if (response.text.message === "Successfully updated") {
              this.props.getalertMessage('edit',response.text.message)
          }
        }
        response.status === 400 && this.props.getalertMessage('warning',response.text.message)
        response.status === 401 && this.unauthorisedFunc()

      })
      .catch(error => {
        this.props.getalertMessage('error',error.toString());
      });
  }

  updateValue = (name, value) => {
    let systemSupplier = { ...this.state.systemSupplier };
    systemSupplier[name] = value;
    this.setState({
      systemSupplier
    });
  }

  render() {
    const { systemSupplier } = this.state;

    return (
      <Fragment>
        <div class="right-section bg-white">
          <div class="row nopadding">
            <PageHeader 
                history = {this.props.history}
                header={`${this.state.action} System Supplier`} 
            />
            <div class="col-md-12 nopadding">
              <div class="col-md-8 col-md-offset-2 no-padding">
                <div class="col-md-12 no-padding">
                  <div class="col-md-3">
                    <Field
                      isFormGroup={true}
                      inputType={"text"}
                      inputName={"supplierCode"}
                      value={systemSupplier.supplierCode}
                      label="Supplier Code"
                      onChange={this.updateValue}
                      disabled={this.state.disabled}
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <Field
                    isFormGroup={true}
                    inputType={"text"}
                    inputName={"supplierName"}
                    value={systemSupplier.supplierName}
                    label="Supplier Name"
                    onChange={this.updateValue}
                    disabled={this.state.disabled}
                  />
                </div>

                <div class="col-md-6">
                  <Field
                    isFormGroup={true}
                    inputType={"text"}
                    inputName={"supplierPhone"}
                    value={systemSupplier.supplierPhone}
                    label="Supplier Phone"
                    onChange={this.updateValue}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-6">
                  <Field
                    isFormGroup={true}
                    inputType={"text"}
                    inputName={"supplierEmail"}
                    value={systemSupplier.supplierEmail}
                    label="Supplier Email"
                    onChange={this.updateValue}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-6">
                  <Field
                    isFormGroup={true}
                    inputType={"text"}
                    inputName={"supplierFax"}
                    value={systemSupplier.supplierFax}
                    label="Supplier Fax"
                    onChange={this.updateValue}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-6">
                  <Field
                    isFormGroup={true}
                    inputType={"textarea"}
                    inputName={"supplierAddress"}
                    value={systemSupplier.supplierAddress}
                    label="Supplier Address"
                    onChange={this.updateValue}
                    disabled={this.state.disabled}
                  />
                </div>
                <div class="col-md-12 profile-btn text-center">
                  <Button buttonName="save" onClick={this.createSupplier} />
                  <Button
                    buttonType="cancel"
                    buttonName="back"
                    history={this.props.history}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default SystemSupplier;



// WEBPACK FOOTER //
// ./src/pages/systemSupplier/page.js